<template>

    <div v-if="items.length" class="dropdown">

        <v-dropdown-toggle v-click-outside="hideMenu"
            :size="size"
            :type="type"
            :prefix="prefix"
            :label="toggleLabel"
            @click.native="toggleMenu">
        </v-dropdown-toggle>

        <transition name="dropdown">
            <div v-show="show" class="dropdown-menu" :class="{ 'menu-right': menuRight }" :style="width ? `width:${width}px;` : ''">
                <div v-if="searchable" class="dropdown-searchbar">
                    <v-searchbar size="sm" :mag="false" :model="query" @input="query = $event" />
                </div>
                <div v-if="filteredItems.length">
                    <a v-for="item in filteredItems" :key="'dd-'+item.key" class="dropdown-item" :class="{ active: key === item.key }" href="#" @click.stop.prevent="selectItem(item)">{{ item.value | truncate(30) }}</a>
                </div>
                <div v-else class="pl-10 pr-10">
                    <v-notice size="sm" message="No Results" />
                </div>
            </div>
        </transition>

    </div>

</template>

<style scoped lang="scss">

    .dropdown {

        flex-shrink: 0;
        position: relative;

        .dropdown-menu {
            @include shad(2);
            background: #fff;
            border: 1px solid $color-rule;
            border-radius: 5px;
            box-sizing: border-box;
            display: block;
            left: 0;
            margin: 5px 0 0 0;
            max-height: 250px;
            max-width: 400px;
            min-width: 200px;
            overflow: auto;
            padding: 10px 0;
            position: absolute;
            z-index: 100;
            &.menu-right {
                left: auto;
                right: 0;
            }
        }

        .dropdown-item {
            @include font-medium(12px);
            align-items: center;
            background: #fff;
            border: none;
            color: $color-text;
            display: flex;
            height: 26px;
            justify-content: space-between;
            margin: 0;
            padding: 0 35px 0 15px;
            position: relative;
            text-decoration: none;
            transition: all .3s;
            user-select: none;
            &:first-child {
                border: none;
            }
            &:hover {
                background-color: $color-highlight;
            }
            &.active {
                color: $color-primary;
                &::after {
                    content: "";
                    background: $color-primary;
                    border-radius: 3px;
                    display: block;
                    height: 6px;
                    margin: 11px 15px;
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 6px;
                }
            }
        }

        .dropdown-searchbar {
            padding: 0 10px 10px 10px;
            > * { min-width: auto; }
        }

        &.d-block {
            .dropdown-toggle {
                width: 100%;
            }
            .dropdown-menu {
                width: 100%;
            }
        }

    }

</style>

<script>

import ClickOutside from 'vue-click-outside';

export default {

    directives: {
        ClickOutside,
    },

    props: {
        size: {
            type: String,
            default: 'sm',
        },
        width: {
            type: Number,
        },
        type: {
            type: String,
            default: 'white',
        },
        items: {
            type: Array,
            required: true,
        },
        prefix: {
            type: String,
            default: '',
        },
        label: {
            type: String,
        },
        selected: {
            type: String,
            default: '',
        },
        showSelected: {
            type: Boolean,
            default: true,
        },
        menuRight: {
            type: Boolean,
            default: false,
        },
        searchable: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            key: this.selected,
            query: '',
            show: false,
        }
    },

    computed: {

        selectedItem() {
            return this.items.find(i => i.key === this.key);
        },

        filteredItems() {
            return this.items.filter(i => {
                return !this.query || i.value.toLowerCase().includes(this.query.toLowerCase());
            });
        },

        toggleLabel() {
            return this.showSelected && this.selectedItem ? this.selectedItem.value : this.label;
        },

    },

    watch: {

        selected(val) {
            this.key = val;
        },

    },

    methods: {

        selectItem(item) {
            this.$emit('change', item);
            if (this.showSelected === true) {
                this.key = item.key;
            }
            this.hideMenu();
        },

        toggleMenu() {
            this.show = !this.show;
        },

        hideMenu(e) {
            if (e !== undefined && e.target.closest('.dropdown-menu')) return;
            this.show = false;
        },

    },

}

</script>
